import React, { useState } from 'react';
import { X } from 'lucide-react';

export const FacilityGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    {
      url: 'https://customer-assets.emergentagent.com/job_filmschool-react/artifacts/kd1fgkfh_Office%202.jpeg',
      title: 'Professional Editing Suites'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_filmschool-react/artifacts/kg9j6x3k_Office%203.jpeg',
      title: 'State-of-the-Art Workstations'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_coursecraft-26/artifacts/2dgesckx_Soundarraj%20Teaching.jpeg',
      title: 'Expert-Led Training Sessions'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_filmschool-react/artifacts/wfse1rb7_Seminar%201.jpeg',
      title: 'Interactive Learning Sessions'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_coursecraft-26/artifacts/9p28t5hn_Workafella%20New.png',
      title: 'Modern Workspace-Like Training Environment for Students',
      imageStyle: { objectFit: 'cover' }
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_filmschool-react/artifacts/qttj372s_IMG_8635.jpg',
      title: 'Comfortable Lounge Area'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_coursecraft-26/artifacts/2srx1714_Office.png',
      title: 'Student Break Area & Lounge'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_filmschool-react/artifacts/dbywzkcu_IMG_8636.jpg',
      title: 'Student Pantry & Free Beverages'
    }
  ];

  return (
    <>
      <section className="py-12 bg-gradient-to-br from-slate-50 to-purple-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-8">
            <h3 className="text-2xl md:text-3xl font-bold text-slate-900">
              Our <span className="bg-gradient-to-r from-purple-600 to-orange-600 bg-clip-text text-transparent">Centre in Bangalore</span>
            </h3>
            <p className="text-slate-600 text-sm mt-2">Professional environment for hands-on learning • Click to enlarge</p>
          </div>
          
          <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4">
            {images.map((image, idx) => (
              <div 
                key={idx}
                onClick={() => setSelectedImage(image)}
                className="relative group overflow-hidden rounded-xl border border-slate-200 shadow-md hover:shadow-xl transition-all duration-300 transform hover:scale-105 cursor-pointer"
                style={image.imageStyle ? { backgroundColor: image.imageStyle.backgroundColor } : {}}
              >
                <img 
                  src={image.url} 
                  alt={image.title}
                  loading="lazy"
                  className="w-full h-48 object-cover"
                  style={image.imageStyle || {}}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <p className="text-white font-semibold text-sm">{image.title}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/90 z-[99999] flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button 
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 text-white bg-black/50 rounded-full p-2 hover:bg-black/70 transition-colors"
          >
            <X className="h-6 w-6" />
          </button>
          <div className="max-w-5xl max-h-[90vh] w-full">
            <img 
              src={selectedImage.url}
              alt={selectedImage.title}
              className="w-full h-full object-contain rounded-lg"
            />
            <p className="text-white text-center mt-4 text-lg font-semibold">{selectedImage.title}</p>
          </div>
        </div>
      )}
    </>
  );
};
